var map = {
	"./1.jpg": 610,
	"./2.jpg": 611,
	"./3.jpg": 612,
	"./4.jpg": 613,
	"./5.jpg": 614,
	"./6.jpg": 615,
	"./7.jpg": 616,
	"./8.jpg": 617,
	"./_old/0.jpg": 618,
	"./_old/1.jpg": 619,
	"./_old/2.jpg": 620,
	"./_old/3.jpg": 621,
	"./_old/4.jpg": 622,
	"./_old/5.jpg": 623,
	"./_old/6.jpg": 624,
	"./_old/7.jpg": 625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 609;